<template>
  <div id="CircleRespondets">
    <div class="respondents">
      <div class="respondents__inner">
        <h2>{{ respondents }}</h2>
        <p v-if="!label">Respondents</p>
        <p v-else>{{ label }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CircleRespondents",
  props: ["respondents", "label"],
};
</script>
<style lang="less">
@import "../../assets/components/common/CircleRespondets.less";
</style>